(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    if (document.documentElement.lang.toLowerCase().startsWith('he')) {
    const replacements = new Map([
      ['Email me with news and offers', 'שלחו לי חדשות והטבות מפליימייקר'],
      ['Quick links', 'קישורים לחשבון']
    ]);
    const watched = new WeakSet();
    const translate = (root) => {
      if (!root) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const replacement = replacements.get(node.textContent.trim());
        if (replacement) node.textContent = replacement;
      }
      root.querySelectorAll('[aria-label]').forEach((element) => {
        const replacement = replacements.get(element.getAttribute('aria-label'));
        if (replacement) element.setAttribute('aria-label', replacement);
      });
      root.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot) translate(element.shadowRoot);
      });
      if (!watched.has(root)) {
        watched.add(root);
        new MutationObserver(() => translate(root)).observe(root, { childList: true, subtree: true, characterData: true });
      }
    };
    customElements.whenDefined('shopify-account').then(() => {
      document.querySelectorAll('shopify-account').forEach((account) => {
        translate(account.shadowRoot);
        account.addEventListener('open', () => {
          translate(account.shadowRoot);
          let attempts = 0;
          const retry = setInterval(() => {
            translate(account.shadowRoot);
            if (++attempts >= 8) clearInterval(retry);
          }, 250);
        });
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
